// eslint-disable-next-line @typescript-eslint/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { OrderBy,TypeViz} from '../../context/TypeDataviz';
import { useEffect, useState } from 'react';

export const useFiltersEncodeSunburst = () => {
	const sunburstStorage = localStorage.getItem('sunburstStorage');
	const [datesFilter, setDateFilters] = useState<any>(null);
	const [metricDataviz, setMetricDataviz] = useState<null | TypeViz>(null);
	const [needRefreshAngularJs, setNeedRefreshAngularJs] = useState<boolean>(false);
	const [orderBySelect, setorderBySelect] = useState<OrderBy | null>(null);
	const [tenantselect, setTenantSelect] = useState<any>();
	function checkMetricDataviz (filtersObj){
		if (filtersObj.hasOwnProperty('metricDataviz')) {
			try {
				const decodedData = filtersObj.metricDataviz;
				if(decodedData.length === 0){
					setMetricDataviz(TypeViz.Pagetype);
				}else{
					setMetricDataviz(decodedData);
				}
			} catch (error) {
				console.error('Failed to decode funnelFilter from URL:', error);
			}
		}else{		
			setNeedRefreshAngularJs(true);
			if(sunburstStorage){
				const sunburstHasMetricDataviz = JSON.parse(sunburstStorage);
				if(sunburstHasMetricDataviz && sunburstHasMetricDataviz.hasOwnProperty('metricDataviz')){
					const decodedData = sunburstHasMetricDataviz.metricDataviz;
					setMetricDataviz(decodedData);
					if(decodedData.length === 0){
						setMetricDataviz(TypeViz.Pagetype);
					}else{
						setMetricDataviz(decodedData);
					}
				}else{
					setMetricDataviz(TypeViz.Pagetype);
				}
			}else{
				setMetricDataviz(TypeViz.Pagetype);
			}

		}
	}

	function checkFilterDates(filtersObj){
		if (filtersObj.hasOwnProperty('dates')) {
			try {
				const decodedData = filtersObj.dates.split(',');
				const decodedDataSplit =  decodedData.reduce((acc, item) => {
					const [key, value] = item.split('=');
					acc[key] = value;
					return acc;
				}, {});
				setDateFilters(decodedDataSplit);
			} catch (error) {
				console.error('Failed to decode funnelFilter from URL:', error);
			}
		}else{
			setNeedRefreshAngularJs(true);
			if(sunburstStorage){
				const sunbursthasDates = JSON.parse(sunburstStorage);
				if(sunbursthasDates && sunbursthasDates.hasOwnProperty('dates')){
					const decodedData = sunbursthasDates.dates.split(',');
					const decodedDataSplit =  decodedData.reduce((acc, item) => {
						const [key, value] = item.split('=');
						acc[key] = value;
						return acc;
					}, {});
					setDateFilters(decodedDataSplit);
				}else{
					setDateFilters(null);
				}
			}else{
				setDateFilters(null);

			}
		}
	}
	function checkOrderBy(filtersObj){
		if (filtersObj.hasOwnProperty('orderBy')) {
			try {
				const decodedData = filtersObj.orderBy;
				if(decodedData.length === 0){
					setorderBySelect(OrderBy.SessionCount);
				}else{
					setorderBySelect(decodedData);
				}
				setorderBySelect(decodedData);
			} catch (error) {
				console.error('Failed to decode funnelFilter from URL:', error);
			}
		}else{
			setNeedRefreshAngularJs(true);
			if(sunburstStorage){
				const sunbursthasOrderBy= JSON.parse(sunburstStorage);
				if(sunbursthasOrderBy && sunbursthasOrderBy.hasOwnProperty('orderBy')){
					const decodedData = sunbursthasOrderBy.orderBy;
					setorderBySelect(decodedData);
				}else{
					setorderBySelect(OrderBy.SessionCount);
				}
			}else{
				setorderBySelect(OrderBy.SessionCount);

			}
		}
	}
	function checkTenant(filtersObj){
		if (filtersObj.hasOwnProperty('tenant')) {
			try {
				const decodedData = filtersObj.tenant;
				if(decodedData.length === 0){
					setTenantSelect('notenant');
				}else{
					setTenantSelect(decodedData);
				}
				
			} catch (error) {
				console.error('Failed to decode funnelFilter from URL:', error);
			}
		}else{
			setNeedRefreshAngularJs(true);
			if(sunburstStorage){
				const sunbursthasTenant= JSON.parse(sunburstStorage);
				if(sunbursthasTenant && sunbursthasTenant.hasOwnProperty('tenant')){
					const decodedData = sunbursthasTenant.tenant;
					setTenantSelect(decodedData);
				}else{
					setTenantSelect('notenant');
				}
			}else{
				setTenantSelect('notenant');

			}
		}
	}


	useEffect(() => {
		const url = new URL(window.location.href);
		const params = url.searchParams;
		const filtersObj: any = {};

		params.forEach((value, key) => {
			filtersObj[key] = value;
		});
		checkTenant(filtersObj);
		checkMetricDataviz(filtersObj);
		checkFilterDates(filtersObj);
		checkOrderBy(filtersObj);
	}, []);


	return {
		metricDataviz
		,datesFilter,
		needRefreshAngularJs,
		orderBySelect,
		setNeedRefreshAngularJs,
		tenantselect
	};
};

